import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

import useAuthUser from '@/composables/useAuthUser'

import { Company } from '@/modules/companies/interfaces/company'
import { UserFilters } from '@/modules/users/interfaces/userFilters'

export const useUserFilterStore = defineStore('userFilter', () => {
	const { user } = useAuthUser()

	const params: { [key: string]: any } = reactive<UserFilters>({
		company: user.value?.internal ? undefined : user.value?.companyId,
		search: '',
		status: 'active',
		role: undefined,
		group: undefined,
		department: undefined,
		sortBy: 'name',
		sortDirection: 'asc',
	})

	const selectedCompany = ref<Company>()

	// Función para limpiar valores nulos/vacíos antes de enviar
	const getCleanParams = () => {
		const cleanParams: { [key: string]: any } = {}

		Object.entries(params).forEach(([key, value]) => {
			// No incluir valores nulos, undefined, strings vacíos, o arrays vacíos
			if (
				value !== null &&
				value !== undefined &&
				value !== '' &&
				!(Array.isArray(value) && value.length === 0)
			) {
				// Para valores por defecto que no queremos enviar
				if (key === 'status' && value === 'active') return
				if (key === 'sortBy' && value === 'name') return
				if (key === 'sortDirection' && value === 'asc') return

				cleanParams[key] = value
			}
		})

		return cleanParams
	}

	return {
		selectedCompany,
		params,
		getCleanParams,

		resetFilters() {
			Object.keys(params).forEach((key) => {
				if (key === 'company') {
					params[key] = user.value?.internal ? undefined : user.value?.companyId
				} else if (key === 'search') params[key] = ''
				else if (key === 'status') params[key] = 'active'
				else if (key === 'sortBy') params[key] = 'name'
				else if (key === 'sortDirection') params[key] = 'asc'
				else params[key] = null
			})
			selectedCompany.value = undefined
		},

		setFilterValue(key: string, value: any) {
			params[key] = value
		},
	}
})
